import { render, staticRenderFns } from "./Dentistry.vue?vue&type=template&id=60780e69&scoped=true"
import script from "./Dentistry.vue?vue&type=script&lang=js"
export * from "./Dentistry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60780e69",
  null
  
)

export default component.exports